// Real industrial drone inventory for UAVs For Sale marketplace
export const realDroneInventory = [
  {
    id: 1,
    model: 'DJI Matrice 350 RTK',
    category: 'Inspection',
    brand: 'DJI',
    condition: 'New',
    price: 14500,
    currency: "USD",
    currency: 'USD',
    priceFormatted: '$14,500',
    location: 'Los Angeles, CA',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=800&q=80',
    description: 'Enterprise-grade inspection platform with RTK precision positioning. Perfect for infrastructure inspection, surveying, and industrial applications.',
    specs: {
      flightTime: '55 min',
      maxSpeed: '23 m/s',
      payload: '2.7 kg',
      camera: '4K 60fps',
      range: '20 km',
    },
    features: ['RTK Positioning', 'Obstacle Avoidance', 'IP55 Rating', 'Hot-swappable Batteries'],
    vendor: 'SkyTech Solutions',
    vendorEmail: 'sales@skytech.example',
    featured: true,
  },
  {
    id: 2,
    model: 'WingtraOne Gen II',
    category: 'Surveying',
    brand: 'Wingtra',
    condition: 'New',
    price: 28000,
    currency: "USD",
    priceFormatted: '$28,000',
    location: 'Denver, CO',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1639847648040-b1af1ce3cecf?w=800&q=80',
    description: 'Professional VTOL mapping drone with survey-grade accuracy. Combines the efficiency of fixed-wing with VTOL convenience.',
    specs: {
      flightTime: '59 min',
      maxSpeed: '16 m/s',
      payload: '1.6 kg',
      camera: '42 MP',
      range: '12 km',
    },
    features: ['VTOL Capability', 'PPK/RTK', 'Survey Grade Accuracy', '500 acres per flight'],
    vendor: 'Precision Mapping LLC',
    vendorEmail: 'info@precisionmapping.example',
    featured: true,
  },
  {
    id: 3,
    model: 'Freefly Alta X',
    category: 'Cinematography',
    brand: 'Freefly',
    condition: 'Used',
    price: 12500,
    currency: "USD",
    priceFormatted: '$12,500',
    location: 'Hollywood, CA',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1753781467329-416d05e7e477?w=800&q=80',
    description: 'Heavy-lift cinema drone capable of carrying professional camera systems. Folding design for easy transport.',
    specs: {
      flightTime: '26 min',
      maxSpeed: '14 m/s',
      payload: '15.9 kg',
      camera: 'Universal Mount',
      range: '5 km',
    },
    features: ['Folding Arms', 'Quick Release Props', 'Heavy Payload', 'Professional Grade'],
    vendor: 'Cinema Aerials Pro',
    vendorEmail: 'contact@cinemaaerials.example',
    featured: false,
  },
  {
    id: 4,
    model: 'Parrot Anafi USA',
    category: 'Security',
    brand: 'Parrot',
    condition: 'New',
    price: 7500,
    currency: "USD",
    priceFormatted: '$7,500',
    location: 'Washington, DC',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1721969661090-22850761bb70?w=800&q=80',
    description: 'Secure drone platform designed for government and defense applications. Made in USA with encrypted communications.',
    specs: {
      flightTime: '32 min',
      maxSpeed: '15 m/s',
      payload: '0.5 kg',
      camera: 'Thermal + 4K',
      range: '4 km',
    },
    features: ['Encrypted Data', 'Thermal Imaging', 'Zoom Camera', 'Cybersecure'],
    vendor: 'Federal Drone Systems',
    vendorEmail: 'sales@federaldrones.example',
    featured: true,
  },
  {
    id: 5,
    model: 'Teledyne FLIR Siras',
    category: 'Inspection',
    brand: 'Teledyne FLIR',
    condition: 'New',
    price: 9500,
    currency: "USD",
    priceFormatted: '$9,500',
    location: 'Boston, MA',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1508614999368-9260051292e5?w=800&q=80',
    description: 'Professional thermal inspection drone with dual cameras. Perfect for infrastructure, solar panel, and building inspections.',
    specs: {
      flightTime: '31 min',
      maxSpeed: '15 m/s',
      payload: '0.8 kg',
      camera: 'Thermal + Visual',
      range: '6 km',
    },
    features: ['Thermal Camera', 'Radiometric Data', 'IP54 Rating', 'Quick Deploy'],
    vendor: 'Thermal Inspection Co',
    vendorEmail: 'info@thermalinspection.example',
    featured: false,
  },
  {
    id: 6,
    model: 'DJI Agras T40',
    category: 'Agriculture',
    brand: 'DJI',
    condition: 'New',
    price: 16800,
    currency: "USD",
    priceFormatted: '$16,800',
    location: 'Fresno, CA',
    country: 'united-states',
    image: 'https://images.pexels.com/photos/3634730/pexels-photo-3634730.jpeg?w=800&q=80',
    description: 'Agricultural spraying drone with 40kg payload. Revolutionize your farming operations with precision agriculture.',
    specs: {
      flightTime: '18 min',
      maxSpeed: '10 m/s',
      payload: '40 kg',
      camera: 'FPV + Mapping',
      range: '5 km',
    },
    features: ['40L Tank', '9m Spray Width', 'Terrain Follow', 'Auto Return'],
    vendor: 'AgriTech Drones',
    vendorEmail: 'sales@agritech.example',
    featured: true,
  },
  {
    id: 7,
    model: 'Autel Dragonfish',
    category: 'Surveying',
    brand: 'Autel',
    condition: 'New',
    price: 32000,
    currency: "USD",
    priceFormatted: '$32,000',
    location: 'Seattle, WA',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1523133045649-1a132addedd4?w=800&q=80',
    description: 'Long-range VTOL drone with 2-hour flight time. Ideal for large-scale mapping, search and rescue, and surveillance.',
    specs: {
      flightTime: '120 min',
      maxSpeed: '20 m/s',
      payload: '1 kg',
      camera: '20MP + Thermal',
      range: '30 km',
    },
    features: ['Extended Range', 'VTOL', 'Dual Camera', 'Weather Resistant'],
    vendor: 'Long Range UAV Systems',
    vendorEmail: 'info@longrangeuav.example',
    featured: false,
  },
  {
    id: 8,
    model: 'DJI Mavic 3 Enterprise',
    category: 'Inspection',
    brand: 'DJI',
    condition: 'Used',
    price: 4800,
    currency: "USD",
    priceFormatted: '$4,800',
    location: 'Austin, TX',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1456615913800-c33540eac399?w=800&q=80',
    description: 'Compact enterprise drone with mechanical shutter and RTK module. Perfect for professionals needing portability.',
    specs: {
      flightTime: '45 min',
      maxSpeed: '19 m/s',
      payload: '0.3 kg',
      camera: '20MP Hasselblad',
      range: '15 km',
    },
    features: ['Compact Design', 'RTK Module', 'Mechanical Shutter', '56x Zoom'],
    vendor: 'Enterprise Drone Hub',
    vendorEmail: 'sales@enterprisedronehub.example',
    featured: false,
  },
  {
    id: 9,
    model: 'Skydio X2D',
    category: 'Security',
    brand: 'Skydio',
    condition: 'New',
    price: 11000,
    currency: "USD",
    priceFormatted: '$11,000',
    location: 'San Francisco, CA',
    country: 'united-states',
    image: 'https://images.pexels.com/photos/22500569/pexels-photo-22500569.png?w=800&q=80',
    description: 'AI-powered autonomous drone with advanced obstacle avoidance. Made in USA for defense and security applications.',
    specs: {
      flightTime: '35 min',
      maxSpeed: '14 m/s',
      payload: '0.4 kg',
      camera: 'Thermal + 4K',
      range: '6 km',
    },
    features: ['Autonomous Flight', '360° Obstacle Avoidance', 'US Made', 'Encrypted'],
    vendor: 'Secure Flight Systems',
    vendorEmail: 'contact@secureflight.example',
    featured: true,
  },
  {
    id: 10,
    model: 'senseFly eBee X',
    category: 'Surveying',
    brand: 'senseFly',
    condition: 'Used',
    price: 18500,
    currency: "USD",
    priceFormatted: '$18,500',
    location: 'Phoenix, AZ',
    country: 'united-states',
    image: 'https://images.pexels.com/photos/27488428/pexels-photo-27488428.jpeg?w=800&q=80',
    description: 'Fixed-wing mapping drone with incredible efficiency. Cover massive areas with survey-grade accuracy.',
    specs: {
      flightTime: '90 min',
      maxSpeed: '16 m/s',
      payload: '1.2 kg',
      camera: 'Modular',
      range: '40 km',
    },
    features: ['Fixed Wing', 'Long Range', 'Survey Grade', 'Easy Launch'],
    vendor: 'Aerial Survey Pros',
    vendorEmail: 'info@aerialsurvey.example',
    featured: false,
  },
  {
    id: 11,
    model: 'Yuneec H520E',
    category: 'Inspection',
    brand: 'Yuneec',
    condition: 'New',
    price: 6500,
    currency: "USD",
    priceFormatted: '$6,500',
    location: 'Miami, FL',
    country: 'united-states',
    image: 'https://images.pexels.com/photos/19156501/pexels-photo-19156501.jpeg?w=800&q=80',
    description: 'Commercial hexacopter with E90 camera. Reliable platform for inspection and documentation work.',
    specs: {
      flightTime: '28 min',
      maxSpeed: '14 m/s',
      payload: '1 kg',
      camera: '20MP 1" Sensor',
      range: '3 km',
    },
    features: ['Hexacopter', 'Hot-Swap Cameras', 'DataPilot Software', 'Reliable'],
    vendor: 'Commercial Drone Solutions',
    vendorEmail: 'sales@commercialdrone.example',
    featured: false,
  },
  {
    id: 12,
    model: 'DJI M30T',
    category: 'Search & Rescue',
    brand: 'DJI',
    condition: 'New',
    price: 13500,
    currency: "USD",
    priceFormatted: '$13,500',
    location: 'Chicago, IL',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=800&q=80',
    description: 'All-in-one emergency response drone with thermal, zoom, and wide cameras. Built for first responders.',
    specs: {
      flightTime: '41 min',
      maxSpeed: '23 m/s',
      payload: '0.5 kg',
      camera: 'Triple Camera',
      range: '15 km',
    },
    features: ['Thermal + Zoom + Wide', 'IP55 Rating', 'Night Vision', 'Emergency Response'],
    vendor: 'First Response Drones',
    vendorEmail: 'info@firstresponsedrones.example',
    featured: true,
  },
  // Racing Drones
  {
    id: 13,
    model: 'IFlight Nazgul5 V3',
    category: 'Racing',
    brand: 'IFlight',
    condition: 'New',
    price: 450,
    currency: 'USD',
    priceFormatted: '$450',
    location: 'San Diego, CA',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1579829366248-204fe8413f31?w=800&q=80',
    description: 'Professional FPV racing quad with 6S power system. Ready-to-fly with top-tier components for competitive racing.',
    specs: {
      flightTime: '5 min',
      maxSpeed: '45 m/s',
      payload: '0.2 kg',
      camera: 'HD FPV',
      range: '2 km',
    },
    features: ['6S Power', 'DJI O3 Compatible', 'Carbon Frame', 'Racing Motors'],
    vendor: 'FPV Racing Supply',
    vendorEmail: 'sales@fpvracing.example',
    featured: false,
  },
  {
    id: 14,
    model: 'BetaFPV X-Knight 360',
    category: 'Racing',
    brand: 'BetaFPV',
    condition: 'New',
    price: 380,
    currency: 'USD',
    priceFormatted: '$380',
    location: 'Portland, OR',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1527977966376-1c8408f9f108?w=800&q=80',
    description: 'Versatile FPV quad designed for both racing and freestyle flying. Features a durable 360-degree protection frame.',
    specs: {
      flightTime: '6 min',
      maxSpeed: '35 m/s',
      payload: '0.15 kg',
      camera: 'Caddx Ratel 2',
      range: '1.5 km',
    },
    features: ['360° Frame Guard', 'HD Recording', 'Analog/Digital', 'Freestyle Ready'],
    vendor: 'Drone Racing League Store',
    vendorEmail: 'info@drlstore.example',
    featured: true,
  },
  {
    id: 15,
    model: 'DJI FPV Combo',
    category: 'Racing',
    brand: 'DJI',
    condition: 'Used',
    price: 850,
    currency: 'USD',
    priceFormatted: '$850',
    location: 'Las Vegas, NV',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1507582020474-9a35b7d455d9?w=800&q=80',
    description: 'Immersive FPV experience with DJIs signature reliability. Perfect for beginners entering the FPV racing world.',
    specs: {
      flightTime: '20 min',
      maxSpeed: '39 m/s',
      payload: '0.3 kg',
      camera: '4K 60fps',
      range: '10 km',
    },
    features: ['Motion Controller', 'Emergency Brake', '4K Recording', 'S Mode 0-100 in 2s'],
    vendor: 'FPV Adventures',
    vendorEmail: 'contact@fpvadventures.example',
    featured: false,
  },
  // Delivery Drones
  {
    id: 16,
    model: 'Flytrex Sky',
    category: 'Delivery',
    brand: 'Flytrex',
    condition: 'New',
    price: 45000,
    currency: 'USD',
    priceFormatted: '$45,000',
    location: 'Dallas, TX',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1611068661807-8e919d02854a?w=800&q=80',
    description: 'Commercial delivery drone designed for last-mile logistics. FAA-approved for BVLOS operations in select areas.',
    specs: {
      flightTime: '25 min',
      maxSpeed: '15 m/s',
      payload: '3 kg',
      camera: 'Navigation Only',
      range: '8 km',
    },
    features: ['Automated Delivery', 'Winch Release', 'UTM Integration', 'FAA Compliant'],
    vendor: 'Urban Delivery Systems',
    vendorEmail: 'info@urbandelivery.example',
    featured: true,
  },
  {
    id: 17,
    model: 'Wingcopter 198',
    category: 'Delivery',
    brand: 'Wingcopter',
    condition: 'New',
    price: 85000,
    currency: 'EUR',
    priceFormatted: '€85,000',
    location: 'Frankfurt, Germany',
    country: 'germany',
    image: 'https://images.unsplash.com/photo-1559057070-d8d10cc01f20?w=800&q=80',
    description: 'eVTOL delivery drone with triple-drop capability. Designed for medical supply delivery and urgent logistics.',
    specs: {
      flightTime: '110 min',
      maxSpeed: '36 m/s',
      payload: '6 kg',
      camera: 'Vision System',
      range: '120 km',
    },
    features: ['Triple Drop', 'Medical Grade', 'VTOL + Fixed Wing', 'All Weather'],
    vendor: 'European Drone Logistics',
    vendorEmail: 'sales@eurodrone.example',
    featured: true,
  },
  {
    id: 18,
    model: 'DJI FlyCart 30',
    category: 'Delivery',
    brand: 'DJI',
    condition: 'New',
    price: 18500,
    currency: 'USD',
    priceFormatted: '$18,500',
    location: 'Houston, TX',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    description: 'Heavy-duty cargo drone with 30kg payload capacity. Ideal for construction sites, remote locations, and emergency supply drops.',
    specs: {
      flightTime: '18 min',
      maxSpeed: '20 m/s',
      payload: '30 kg',
      camera: 'Dual FPV',
      range: '16 km',
    },
    features: ['30kg Payload', 'Cargo Winch', 'Dual Battery', 'All Weather IP55'],
    vendor: 'Heavy Lift Solutions',
    vendorEmail: 'info@heavylift.example',
    featured: false,
  },
  // Thermal Inspection Drones
  {
    id: 19,
    model: 'FLIR Vue TZ20-R',
    category: 'Thermal Inspection',
    brand: 'FLIR',
    condition: 'New',
    price: 15500,
    currency: 'USD',
    priceFormatted: '$15,500',
    location: 'Atlanta, GA',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1501630834273-4b5604d2ee31?w=800&q=80',
    description: 'Dual thermal sensor payload with 20x optical zoom. Radiometric imaging for precise temperature measurements.',
    specs: {
      flightTime: '35 min',
      maxSpeed: '18 m/s',
      payload: '0.9 kg',
      camera: 'Dual Thermal + 4K',
      range: '12 km',
    },
    features: ['Radiometric', 'Dual Thermal Sensors', '20x Zoom', 'FLIR MSX'],
    vendor: 'Thermal Imaging Pros',
    vendorEmail: 'sales@thermalpros.example',
    featured: true,
  },
  {
    id: 20,
    model: 'DJI Matrice 30T',
    category: 'Thermal Inspection',
    brand: 'DJI',
    condition: 'New',
    price: 14200,
    currency: 'USD',
    priceFormatted: '$14,200',
    location: 'Minneapolis, MN',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1524143986875-3b098d911279?w=800&q=80',
    description: 'Enterprise thermal inspection platform with wide, zoom, and thermal cameras. Perfect for utility and solar inspections.',
    specs: {
      flightTime: '41 min',
      maxSpeed: '23 m/s',
      payload: '0.5 kg',
      camera: 'Wide + 200x Zoom + Thermal',
      range: '15 km',
    },
    features: ['Triple Camera', 'Spot Metering', 'IP55 Rating', 'Smart Track'],
    vendor: 'Industrial Inspection UAV',
    vendorEmail: 'info@industrialuav.example',
    featured: false,
  },
  {
    id: 21,
    model: 'Autel EVO II Dual 640T V3',
    category: 'Thermal Inspection',
    brand: 'Autel',
    condition: 'Used',
    price: 8900,
    currency: 'USD',
    priceFormatted: '$8,900',
    location: 'Nashville, TN',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1529220502050-f15e570c634e?w=800&q=80',
    description: 'Portable thermal drone with 640x512 resolution thermal sensor. Ideal for building envelope and roof inspections.',
    specs: {
      flightTime: '42 min',
      maxSpeed: '20 m/s',
      payload: '0.4 kg',
      camera: '8K RGB + 640 Thermal',
      range: '15 km',
    },
    features: ['640 Resolution Thermal', '8K Visual', 'Object Detection', 'Compact'],
    vendor: 'SunBelt Drone Services',
    vendorEmail: 'contact@sunbeltdrones.example',
    featured: false,
  },
  // Heavy Lift Drones
  {
    id: 22,
    model: 'Griff Aviation 300',
    category: 'Heavy Lift',
    brand: 'Griff Aviation',
    condition: 'New',
    price: 250000,
    currency: 'USD',
    priceFormatted: '$250,000',
    location: 'Oslo, Norway',
    country: 'norway',
    image: 'https://images.unsplash.com/photo-1509515837298-2c67a3933321?w=800&q=80',
    description: 'Industrial heavy-lift drone capable of 300kg payload. Designed for cargo transport, construction, and wind turbine maintenance.',
    specs: {
      flightTime: '30 min',
      maxSpeed: '12 m/s',
      payload: '300 kg',
      camera: 'Optional Payload',
      range: '8 km',
    },
    features: ['300kg Lift', 'Redundant Systems', 'Industrial Grade', 'Custom Mounts'],
    vendor: 'Heavy Cargo Aviation',
    vendorEmail: 'sales@heavycargo.example',
    featured: true,
  },
  {
    id: 23,
    model: 'Harris Aerial H6 Hybrid',
    category: 'Heavy Lift',
    brand: 'Harris Aerial',
    condition: 'New',
    price: 125000,
    currency: 'USD',
    priceFormatted: '$125,000',
    location: 'Pittsburgh, PA',
    country: 'united-states',
    image: 'https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0?w=800&q=80',
    description: 'Gas-electric hybrid heavy lift platform with 2-hour flight time. Ideal for power line stringing and cargo operations.',
    specs: {
      flightTime: '120 min',
      maxSpeed: '15 m/s',
      payload: '45 kg',
      camera: 'Multiple Options',
      range: '25 km',
    },
    features: ['Hybrid Power', 'Extended Flight', '45kg Payload', 'Line Stringing Kit'],
    vendor: 'Utility Drone Systems',
    vendorEmail: 'info@utilitydrones.example',
    featured: true,
  },
  {
    id: 24,
    model: 'Freefly Alta Pro',
    category: 'Heavy Lift',
    brand: 'Freefly',
    condition: 'Used',
    price: 22000,
    currency: 'GBP',
    priceFormatted: '£22,000',
    location: 'London, UK',
    country: 'united-kingdom',
    image: 'https://images.unsplash.com/photo-1551887373-6edba6dacbb1?w=800&q=80',
    description: 'Professional heavy-lift cinema drone with redundant systems. Carry RED, ARRI, or cinema cameras with ease.',
    specs: {
      flightTime: '20 min',
      maxSpeed: '14 m/s',
      payload: '20 kg',
      camera: 'Cinema Mount',
      range: '5 km',
    },
    features: ['Redundant Props', 'Cinema Grade', 'Vibration Isolated', 'Folding Design'],
    vendor: 'UK Cinema Aerials',
    vendorEmail: 'hire@ukcinema.example',
    featured: false,
  },
];

export const categories = [
  'All Categories',
  'Inspection',
  'Surveying',
  'Cinematography',
  'Security',
  'Agriculture',
  'Search & Rescue',
  'Racing',
  'Delivery',
  'Thermal Inspection',
  'Heavy Lift',
];

export const brands = [
  'All Brands',
  'DJI',
  'Wingtra',
  'Freefly',
  'Parrot',
  'Teledyne FLIR',
  'Autel',
  'Skydio',
  'senseFly',
  'Yuneec',
  'IFlight',
  'BetaFPV',
  'Flytrex',
  'Wingcopter',
  'FLIR',
  'Griff Aviation',
  'Harris Aerial',
];

export const priceRanges = [
  { label: 'All Prices', min: 0, max: Infinity },
  { label: 'Under $10,000', min: 0, max: 10000 },
  { label: '$10,000 - $20,000', min: 10000, max: 20000 },
  { label: '$20,000 - $30,000', min: 20000, max: 30000 },
  { label: 'Over $30,000', min: 30000, max: Infinity },
];

export const countries = [
  { name: 'United States', slug: 'united-states', flag: '🇺🇸', count: 850 },
  { name: 'United Kingdom', slug: 'united-kingdom', flag: '🇬🇧', count: 320 },
  { name: 'Germany', slug: 'germany', flag: '🇩🇪', count: 280 },
  { name: 'France', slug: 'france', flag: '🇫🇷', count: 245 },
  { name: 'Japan', slug: 'japan', flag: '🇯🇵', count: 210 },
  { name: 'China', slug: 'china', flag: '🇨🇳', count: 195 },
  { name: 'Canada', slug: 'canada', flag: '🇨🇦', count: 180 },
  { name: 'Australia', slug: 'australia', flag: '🇦🇺', count: 165 },
  { name: 'Brazil', slug: 'brazil', flag: '🇧🇷', count: 145 },
  { name: 'India', slug: 'india', flag: '🇮🇳', count: 130 },
  { name: 'Singapore', slug: 'singapore', flag: '🇸🇬', count: 95 },
  { name: 'UAE', slug: 'uae', flag: '🇦🇪', count: 85 },
];